import {
	ReconcilliationJobHistoryData,
	ReconcilliationTransactionDetails,
	ReconcilliationTransactionDetailsRequest,
} from "../model/reconcilliation/reconcilliation";
import { apiSlice } from "../stores/base/api-slice";

const serviceBaseurl = "/reconcilliation-job-history";

/**
 * Built by hand because the base query has no params serializer: handing it an array yields one
 * comma-joined value, which the endpoint's Guid[] parameters cannot bind.
 */
const transactionIdsQuery = (request: ReconcilliationTransactionDetailsRequest): string => {
	const params = new URLSearchParams();
	const append = (name: string, ids: string[]) => ids.forEach(id => params.append(name, id));

	append("refundedTransactionIds", request.refundedTransactionIds);
	append("lateTransactionIds", request.lateTransactionIds);
	append("stuckTransactionIds", request.stuckTransactionIds);

	return params.toString();
};

const reconcilliationEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({
		getReconcilliationHistoryData: builder.query<ReconcilliationJobHistoryData | null, string>({
			query: date => ({
				url: serviceBaseurl,
				method: "GET",
				params: { date },
			}),
			providesTags: ["ReconcilliationHistory"],
		}),
		/**
		 * The record stores only ids, so the details tables ask for one page of them at a time —
		 * all three tables in a single request, since the tab shows them together.
		 */
		getReconcilliationTransactionDetails: builder.query<
			ReconcilliationTransactionDetails,
			ReconcilliationTransactionDetailsRequest
		>({
			query: request => ({
				url: `${serviceBaseurl}/transaction-details?${transactionIdsQuery(request)}`,
				method: "GET",
			}),
			providesTags: ["ReconcilliationHistory"],
		}),
		/** Returns a short-lived read url for the report the job archived, as the other pdf downloads do. */
		downloadReconcilliationReport: builder.query<string, string>({
			query: reportId => ({
				url: `/pdf/download-reconcilliation-report/${reportId}`,
				method: "GET",
			}),
		}),
	}),
});

export const {
	useGetReconcilliationHistoryDataQuery,
	useLazyGetReconcilliationHistoryDataQuery,
	useGetReconcilliationTransactionDetailsQuery,
	useLazyDownloadReconcilliationReportQuery,
} = reconcilliationEndpoints;
